// @flow

import { jsonRequest } from '../../utils'

export function addToCartShopify (_customerId: string, _subscriberId: string, productId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    jsonRequest({
      url: window.Shopify.routes.root + 'cart/add.js',
      data: {
        items: [
          {
            id: productId,
            quantity: 1
          }
        ]
      },
      processResponse: (xhr) => {
        if (xhr.status >= 200 && xhr.status < 400) {
          resolve()
        } else {
          reject(new Error('Add-to-cart failed.'))
        }
      }
    })
  })
}
